module.exports = {"corporation":{"shareholder":"Shareholder","director":"Director","officer":"Officer"},"limited_partnership":{"limited_partner":"Limited Partner","general_partner":"General Partner"},"llc":{"llc_member":"Member","llc_manager":"Manager"},"trust":{"trustee":"Trustee","trustor":"Trustor","beneficiary":"Beneficiary"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/entities/resources/partnershipPerType.json
// module id = kU4K
// module chunks = 1